import { mapState, mapMutations } from 'vuex'
import { debounce, isEqual } from 'lodash';
import * as ih from '@core_utils/util'
import DFAttachedFileURL from '@core_components/client/components/subs/elements/DFAttachedFileURL.vue'
import { generateSubcomponentDataBy } from '@core_utils/subComponent/subComponent';
import { getSubFilesInfo } from '@core_utils/api/file_api.js'

export const SubComponentMixin = {
    name: 'sub-component-mixin',
    components: {
        'df-attached-file-url': DFAttachedFileURL
    },
    props: {
        // question_code: {
        //     type: String,
        //     reuqired: true,
        //     default: 'GHG'
        // },
        company_id: {
            type: Number,
            reuqired: true 
        },
        company_name: {
            type: String,
            reuqired: true 
        },
        campaign_id: {
            type: Number,
            reuqired: true 
        },
        sub_id: {
            type: [Object, Number],
            required: false,
            default: null
        },
        sub_init_id: {
            type: [Object, Number],
            required: false,
            default: null
        },
        sub_type: {
            type: String,
            required: true,
            default: 'text_input'
        },
        label: {
            type: String,
            default: null
        },
        sub_code: {
            type: String,
            required: true,
            default: 'ghg_policy'
        },
        sub_name: {
            type: [String, Object],
            default: null
        },
        sub_name_e: {
            type: [String, Object],
            default: null
        },
        sub_name_c: {
            type: [String, Object],
            default: null
        },
        sub_description: {
            type: [String, Object],
            default: null
        },
        sub_description_e: {
            type: [String, Object],
            default: null
        }, 
        sub_description_c: {
            type: [String, Object],
            default: null
        }, 
        sub_info: {
            type: [String, Object],
            default: null
        },
        sub_info_e: {
            type: [String, Object],
            default: null
        }, 
        sub_info_c: {
            type: [String, Object],
            default: null
        }, 
        sub_condition: {
            type: Object,
            default: () => ({ value: null, text: null, })
        },
        sub_data_header: {
            default: () => ({}) 
        },
        sub_data_contents: {
            default: () => ({ structure: [], result: [] })
        },
        sub_priority: {
            type: [String, Number],
            default: ''
        },
        sub_parent: {
            type: [String, Object],
            default: null
        },
        sub_child: {
            type: Array,
            default: () => ([])
        },
        has_pipeline: {
            type: Boolean,
            default: false
        },
        view_pipe_line: {
            type: Boolean,
            default: true
        },
        headers: {
            type: Boolean,
            default: true
        },
        tags: {
            type: Array,
            default: () => ([])
        },
        is_disabled_by_parent: {
            type: Boolean,
            default: false
        },
        preview: {
            type: Boolean
        },
        previous: {
            type: Boolean
        },
        audit_mode: {
            type: Boolean,
            default: false
        },
        is_final_sub_component: {
            type: Boolean,
            default: false
        },
        print_mode: {
            type: Boolean,
            default: false
        },
        no_answers: {
            type: Boolean,
            default: false
        },
        skip_info: {
            type: Boolean,
            default: false
        },
        is_edit_page: {
            type: Boolean, 
            default: false
        },
        last_save_state: {
            type: String,
            default: 'not_saved'
        }
    },
    data () {
        return {
            file: null,
            files: [],
            file_names: [],

            uploaded_file: {
                url: '',
                name: ''
            },

            is_visible_by_pipeline: true,
            prev_sub_info: {
                is_prev_version: false,
                sub_code: null,
                label: null,
                question_info: {
                    question_name: null,
                    question_name_c: null,
                    question_name_e: null,
                    question_code: null,
                }
            },

            file_placeholder:'',
            save_state: 'not_saved',

            validation_comment: '',
            validation_icon: '',
            validation_style: 'ih-validation-saved',

            mode: this.$t('파일 또는 URL 유형선택'),

            is_visible: false,

            url_temp: 'http://',
            file_temp: null,

            child_subs: [],
            score_result: 0,

            is_loaded: false,
            previous_sub: {},

            not_applicable: '',
            original_sub_data_contents: {},
        }
    },
    computed: {
        ...mapState(['question_in_progress', 'view_mode', 'admin_mode', 'response_code']),
        sub_code_label (){
            return this.label ?? this.sub_code
        },
        question_code () {
            return this.$route.params.question_code ?? this.$route.query.question_code 
        },
        is_locked () {
            if (this.question_in_progress.is_completed === 'true') return true
            else return false
        },
        question_subs () {
            return this.$store.state.questions.subs
        },
        is_indicate_description () {
            var indicate_temp = this.sub_description
            if (indicate_temp) {
                indicate_temp.replace(/(\s*)/g,"")
                if (indicate_temp === '') return false
                else return true
            } else {
                return false
            }
        },
        is_disabled_attached () {
            return this.is_locked
                || this.is_disabled_by_condition
                || this.is_disabled_by_parent
                || (this.$options.name !== "df-file-url2" && !this.sub_id)
                || !this.is_visible_by_pipeline
        },
        is_disabled_by_na () {
            return this.sub_data_contents.result == '해당없음'
        },
        is_disabled_by_condition () {
            if(!this.is_sub_condition_activated) return false
            else {
                var x = this.sub_condition.value
                if( x === 'false' ||
                    x === false ||
                    x === '' ||
                    x === undefined ||
                    x === 'undefined' ||
                    x === '아니오' ||
                    x === 0 ||
                    x === '0' ||
                    x === null )
                { return  true }

                else return false
            }
        },
        is_sub_condition_activated () {
            const _sub_condition = typeof this.sub_condition === 'string'
                ? JSON.parse(this.sub_condition)
                : this.sub_condition
            
            if (_sub_condition.text) {
                if (_sub_condition.text !== '') {
                    if (!_sub_condition.value) {
                        this.$set(_sub_condition, 'value', false)
                    }
                    return true
                } else {
                    return false
                }
            } else {
                this.$set(_sub_condition, 'text', '')
                return false
            }
        },
        badge_var(){          
            if (this.sub_priority=='기초'){
                return 'basic'
            }
            else if (this.sub_priority=='심화'){
                return 'advance'
            }
            else if (this.sub_priority=='잠재'){
                return 'emerging'
            }            
        },
        locale(){
            return this.$i18n.locale
        },
        lang_append () {
            const pair_append_locale = {
                'kr': '',
                'ko': '',
                'en': '_ea',
                'ca': '_ca'
            }
            return pair_append_locale[this.$i18n.locale]
        },
        button_title () {
            return this.$t(`평가정보`)
        },
        pipeline_title () {
            return this.$t(`이 문항은 답변할 필요가 없습니다.`)
        },
        file_modal_title () {
            return this.$t(`URL / 파일 첨부하기`)
        },
        form_placeholder () {
            return this.$t(`여기로 끌어오거나, 클릭하여 파일을 찾으세요.`)
        },
        na_state(){
            if (this.sub_data_header.enable_na && this.not_applicable === true && !this.sub_data_contents.na_reason) {
                return false
            } else {
                return null
            }
        },
        required_attachment(){
            return this.sub_data_header?.required_attachment === true
        },
        required_answer(){
            return this.sub_data_header?.required_answer === true
        },
        enable_na_label () {
            return !this.sub_data_header?.enable_na_label
                ? this.$t('해당없음')
                : this.$i18n.locale === "ko"
                    ? this.sub_data_header?.enable_na_label
                    : this.$i18n.locale === "en"
                        ? this.sub_data_header?.enable_na_label_ea
                        : this.sub_data_header?.enable_na_label_ca
        },
        form_id () {
            return this.print_mode
                ? `print-sub-${this.sub_type}-${this.sub_init_id}-cpn-${this.company_id}`
                : `sub-${this.sub_type}-${this.sub_init_id}-cpn-${this.company_id}`
        }
    },
    watch: {
        locale(){
            this.$emit('update-pipeline') //로케일 바뀌면 DB값 다시 읽어와야 함
        },
        save_state (_save_state) {
            if (_save_state === 'saving') {
                this.validation_comment = this.$t(`저장 중 입니다.`)
                this.validation_icon = 'hourglass'
                this.validation_style = 'ih-validation-saving'
            } else if (_save_state === 'saved') {
                this.validation_comment = this.$t(`저장 되었습니다`)
                this.validation_icon = 'check'
                this.validation_style = 'ih-validation-saved'
            } else if (_save_state === 'resaved') {
                this.validation_comment = this.$t(`변경 저장 되었습니다`)
                this.validation_icon = 'check'
                this.validation_style = 'ih-validation-resaved'
            }
        },
        'sub_data_contents.result': {
            deep: true,
            immediate: true,
            handler (_updated_result) {
                if (this.sub_data_header.enable_na === true) {
                    if (_updated_result == '해당없음') {
                        this.not_applicable = true
                    } else if([[], ''].includes(_updated_result) && this.save_state !== 'saved') {
                        this.not_applicable = ''
                    } else {
                        this.not_applicable = false
                    }
                }
            }
        }
    },
    async created () {
        this.save_state = this.last_save_state

        if (this.has_pipeline && this.view_pipe_line) {
            // 파이프라인 가시성 조회 실패가 컴포넌트 렌더 자체를 막지 않도록 격리한다.
            // 여기서 throw 되면 아래 original_sub_data_contents 스냅샷과 initiateData() 가
            // 통째로 실행되지 않아, 답변이 있는 문항이 빈칸으로 보인다.
            try {
                await this.checkPipelineVisibility()
            } catch (error) {
                // raw error 를 그대로 찍으면 axios error.config 에 담긴 Authorization 헤더가
                // 콘솔에 노출되므로, sub_code 와 HTTP status 만 남긴다.
                const _status = error && error.response ? error.response.status : 'network'
                console.error(`[SubComponent] checkPipelineVisibility 실패 (sub_code: ${this.sub_code}, status: ${_status})`)
            }
        }


        this.original_sub_data_contents = ih.deepCopy(this.sub_data_contents)
        await this.initiateData()
    },
    methods: {
        ...mapMutations('questions', ['update_sub']),
        async initiateData() {
            try {
                this.is_loaded = false
                
                if (!this.print_mode && !this.no_answers) {
                    // 차일드 컴포넌트가 존재하는 경우 정보 가져옴
                    if (!!this.sub_child && this.sub_child.length) {
                        await this.readChildSubs()
                    }
                    
                    if (this.sub_type === 'file_URL2') {
                        await this.getFilesFromServer()
                    }
                }
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    await this.common_401_error_handling()
                } else {
                    // 실패한 호출을 같은 파라미터로 재시도해봐야 동일하게 실패할 뿐이므로 재호출하지 않는다.
                    // (기존에는 readChildSubs / getFilesFromServer 를 그대로 다시 불렀다.)
                    // raw error 로깅은 axios error.config 의 Authorization 헤더를 노출하므로 status 만 남긴다.
                    const _status = error && error.response ? error.response.status : 'network'
                    console.error(`[SubComponent] initiateData 실패 (sub_code: ${this.sub_code}, status: ${_status})`)
                }
            } finally {
                this.$emit('sub-load-finished', this.sub_code)
                this.is_loaded = true
            }
        },
        async getFilesFromServer () {
            if(!this.sub_data_contents.result || this.sub_data_contents.result === '해당없음') {
                console.log('저장될 파일이 제대로 지정되지 않았음')
                return
            }

            const res = await getSubFilesInfo({
                campaign_id : this.campaign_id,
                company_id : this.company_id,
                sub_code : this.sub_code
            })

            this.sub_data_contents.result.forEach((v,i) => {
                var targetIndex  = res.findIndex(fileInfo => fileInfo.filename === v.filename)
                //if v.type is URL, simply perceive it to exist
                //"isExist" means that the value stored in "this.sub_data_contents.result"
                // actually exists in the S3 and DFFiles tables
                var isExist = v.type === "URL" || targetIndex > -1
                if (!isExist){
                    this.sub_data_contents.result[i].filename = this.sub_data_contents.result[i].filename + '(오류)'
                    this.sub_data_contents.result[i].file_link = 'File Not Found'
                    return
                }
                this.sub_data_contents.result[i].file_link = res[targetIndex].savepath
            })
            // return
        },
        async readChildSubs () {
            try {
                this.child_subs = []
                let temp_subs = []

                // company_id / campaign_id 는 백엔드 read_sub 의 필수 파라미터다.
                // 빠뜨리면 이 조회는 항상 실패해 자식 sub 가 표시되지 않는다.
                const _res_child_subs = await this.$axios.get('/subs', {
                    params: {
                        sub_codes: this.sub_child.join(','),
                        company_id: this.company_id,
                        campaign_id: this.campaign_id
                    }
                })
                if (_res_child_subs.data && _res_child_subs.data.length) {
                    _res_child_subs.data.forEach(child_subs => {
                        temp_subs.push({
                            ...generateSubcomponentDataBy(child_subs),
                            question_code: this.question_code
                        })
                    });
                }

                this.child_subs = temp_subs
            } catch (error) {
                this.common_error_handling(error)
            }
        },
        async radioSave (update_pipeline = true) {
            // update_pipeline: default: true 만약 element에서 업데이트 한 것이면, pipeline 체크다시 안함
            // change_mode
            this.save_state = 'saving'
            this.debouncedSave(update_pipeline)
        },
        textInputSave(update_pipeline, is_blur = false) {
            if(typeof update_pipeline == "undefined") {
                update_pipeline = false
            }

            this.save_state = 'saving'
            this.debouncedSave(update_pipeline, {text_input_save: true, is_blur})
        },
        debouncedSave: debounce (function (update_pipeline = false, options = {}) {
            this.$nextTick(async () => {
                await this.dbSave(update_pipeline, options)
            })
        }, 800),
        makeMode(new_mode){
            this.mode = new_mode
        },
        async handleOK () {
            if (this.sub_data_contents.length === 0) {
                this.$bvModalEvt.preventDefault()
            }
            await this.dbSave()
        },
        async dbSave (update_pipeline = true, options) {
            try {
                const response = await this.$axios.post('/subs', {
                    sub_id: this.sub_id,
                    sub_init_id: this.sub_init_id,
                    company_id: this.$route.query.cpn ?? this.company_id,
                    company_name: this.$route.query.cpnm ?? this.company_name,
                    campaign_id: this.$route.query.cmp ?? this.campaign_id,
                    question_code: this.question_code,
                    sub_code: this.sub_code,
                    sub_data_contents: this.sub_data_contents,
                    score_result: this.score_result
                })
                
                
                if(options.text_input_save) {
                    if(isEqual(this.sub_data_contents, response.data.sub_data_contents)){
                        this.$store.commit('questions/update_sub', response.data)
                    }
                    else if(options.is_blur){
                        this.$store.commit('questions/update_sub', response.data)
                    }
                }
                else {
                    this.$store.commit('questions/update_sub', response.data)
                }
                
                this.save_state = 'resaved'

                if (response.data.pipeline_updated && update_pipeline) { 
                    this.$emit('update-pipeline', this.save_state)
                } // 파이프라인 변경 되었을 경우 Question 전체를 다시 그림
            } catch (error) {
                if (error.response && error.response.status !== '401') {
                    if (this.$i18n.locale === "ko") {
                        alert('죄송합니다. 답변 저장 중 장애가 발생했습니다. "평가 참여하기" 페이지로 이동하오니 다시 답변해주시기 바랍니다.')
                    } else if (this.$i18n.locale === "en") {
                        alert('We’re sorry. An error occurred while saving your answers. You will be redirected to the "Participate in Evaluation" page. Please try again.');
                    } else {
                        alert('抱歉，保存答案时发生错误。系统将跳转至“参与评估”页面，请重新作答。');
                    }

                    this.$router.push({ name: "Main" })
                }
            }
        },
        handleSubmit(){
            return true
        },
        toggleVisible(){
            this.is_visible = !this.is_visible
        },
        deleteDataContents(item,index){
            var checkItem = this.files[index]
            if (item.file_url_key !== checkItem.file_url_key){
                console.log("Wrong item & index")
                return
            }
        
            this.files.splice(index,1)
            this.files.forEach((fileInfo,index) => fileInfo.file_url_key = index+1)
        },
        addURLToSubDataContents (item) {
            if (this.isValidURL(item) === false) {
                window.alert(this.$t('올바른 URL 형식으로 입력해 주십시오 (http)'))
                return false
            } else {
                if (this.files.any(fi => fi.file_link === item)){
                    return false
                }
                let new_URL_item = {
                    type: 'URL',
                    filename: item,
                    file_link: item,
                    file_url_key: this.file_list.length+1
                }

                this.files.push(new_URL_item)
                this.url_temp = 'http://'
            }
        },
        addFileToSubDataContents (items) {
            //remove duplicated files between item & this.files
            items.forEach((item,index)=>{
                if (this.files.some(fi => fi.filename == item.name)){
                    console.log(`${item.name} alreay in this.files`)
                    return 
                }
                if (item) {
                    let new_file_item = {
                        type: 'file',
                        filename: item.name,
                        file_link: item.name,
                        file_url_key: this.files.length+1+index,
                        file : item
                    }
                    this.files.push(new_file_item)
                }
            })
            this.$nextTick(() => {
                this.file_temp = null
            })
        },
        isValidURL(str) {
            try {
                str = str.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                var regex = new RegExp("[\\?&]" + str + "=([^&#]*)"),
                    results = regex.exec(location.search);
                    results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
                return true
                // ie에서 new URL을 사용할 수 없어 위 코드로 변경함
                // new URL(str);
                // return true;
            } catch (_) {
                return false;
            }
        },
        updateStore(sub_data_contents, sub_condition){
            let new_sub = {
                sub_code: this.sub_code, 
                sub_name: this.sub_name, 
                sub_name_e: this.sub_name_e,
                sub_name_c: this.sub_name_c,
                sub_description: this.sub_description,
                sub_description_e: this.sub_description_e, 
                sub_description_c: this.sub_description_c, 
                sub_info: this.sub_info, 
                sub_info_e: this.sub_info_e,
                sub_info_c: this.sub_info_c,
                sub_condition: sub_condition, 
                sub_type: this.sub_type, 
                sub_data_header: this.sub_data_header,
                sub_data_contents: sub_data_contents,
                sub_priority: this.sub_priority,
                sub_parent: this.sub_parent, 
                sub_child: this.sub_chid,
                save_state: this.save_state,
                score_result: this.score_result
            }
            this.$store.commit('questions/update_sub',new_sub)
        },
        handleUpdateParentContents(sub_data_contents, sub_code){
            let idx = this.child_subs.findIndex(item => { return item.sub_code == sub_code })
            if (idx > -1) {
                let new_sub = { ...this.child_subs[idx] }
                new_sub.sub_data_contents = sub_data_contents
                this.child_subs.splice(idx, 1, new_sub)
            } else {
                console.log('차일드 서브에서 못찾음')
            }
        },
        async checkPipelineVisibility () {
            let campaign_id = this.$route.query.cmp ?? this.$route.query.campaign_id
            let company_id = this.$route.query.cpn ?? this.$route.query.company_id
            let company_name = this.$route.query.cpnm ?? this.company_name
            
            if(this.previous){
                campaign_id = this.campaign_id;
                company_id = this.company_id;
                company_name = this.company_name;
            }
            
            const response = await this.$axios.get('/check_pipeline_visibility', {
                params: {
                    sub_code: this.sub_code,
                    campaign_id,
                    company_id,
                    company_name,
                }
            })
            
            if (response.data && response.data.pipeline_sub_info) {
                this.prev_sub_info = response.data.pipeline_sub_info
                this.prev_sub_info.is_prev_version = this.previous
            }


            let _res_subs = null
            if(this.no_answers){
                _res_subs = await this.$axios.get('/subs_init', {
                    params: { sub_codes: this.sub_code }
                })
            }
            else {
                _res_subs = await this.$axios.get('/subs', {
                    params: { sub_codes: this.sub_code, company_id: this.company_id, campaign_id: this.campaign_id }
                })
            }
            
            // 응답이 비면(sub_code 미존재 등) data[0] 이 undefined 이고,
            // generateSubcomponentDataBy 의 JSON.parse(JSON.stringify(undefined)) 가 SyntaxError 를 던진다.
            // created() 훅에서 호출되므로 그대로 두면 컴포넌트 전체가 렌더되지 않는다.
            const _first_sub = _res_subs && _res_subs.data && _res_subs.data.length
                ? _res_subs.data[0]
                : null

            if (_first_sub) {
                this.$store.commit('questions/update_sub', generateSubcomponentDataBy(_first_sub))
            } else {
                console.warn(`[SubComponent] /subs 응답이 비어 sub 갱신을 건너뜁니다 (sub_code: ${this.sub_code})`)
            }

            this.is_visible_by_pipeline = response.data.visibility
            
        },
        async handleAttachmentSave (new_attachment) {
            const _new_attachment = new_attachment.map((file, index) => ({ ...file, file_url_key: index + 1 }))
            this.sub_data_contents.attachment = _new_attachment
            await this.radioSave()
        },
        async get_file() {
            try {
                let got_file = { url: '', name: '' }
                const response = await this.$axios({
                    method: 'GET',
                    url: '/get_file',
                    params: {
                        requested_file: this.sub_data_contents.file_name,
                        company_name: this.$store.getters.getCompanyName,
                        sub_code: this.sub_code
                    },
                    responseType: 'blob', // important
                })
                got_file['url'] = window.URL.createObjectURL(response.data);
                got_file['name'] = this.sub_data_contents.file_name
                return got_file
            } catch (error) {
                console.log(error)
                if (error.response) {
                    this.common_error_handling(error)
                }
            }
        }
    }
}
